
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CustomEmptyView from "../../../Components/CustomEmptyView";
import Strings from "../../../Config/Strings";
import { getProductsRolePermissions } from "../../../Constants/PermissionConstant";
import { deleteProductsAPI } from "../../../Store/Action/productAction";
import ProductTableBody from "./Controls/ProductTableBody";
import ProductTableHeader from "./Controls/ProductTableHeader";
import Colors from "../../../theme/Colors";
import Pagination from "../../../Components/Pagination";
import DeleteConfirmationPopup from "../../../Components/DeleteConfirmationPopup";
import Icons from "../../../Config/Images";

const ProductTable = ({
  products,
  onViewProductDetails,
  productRolePermission,
  totalItems,
  rowsPerPage,
  handleChangePage,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [productIdToDelete, setProductIdToDelete] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate total pages based on totalItems and rowsPerPage
  const totalPages = Math.ceil(totalItems / rowsPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    handleChangePage(null, newPage - 1); // Adjusting index as per 0-based index system
  };

  const userPermissions = getProductsRolePermissions(productRolePermission);

  const { userData } = useSelector((state) => state.user);

  const handleDeleteProduct = async () => {
    try {
      await dispatch(
        deleteProductsAPI(productIdToDelete, (isSuccess, response) => {
          setShowDeleteModal(false);
          if (isSuccess?.status === true) {
            toast.success(response?.data?.message);
            setTimeout(() => {
              window.location.reload();
            }, 400);
          } else {
            const errorMessage =
              response?.error?.message || Strings.somethingWentWrongError;
            toast.error(errorMessage);
          }
        })
      );
    } catch (error) {
      console.log("Error dispatching deleteProducts:", error);
      toast.error(Strings.somethingWentWrongError);
    }
  };

  const handleShowDeleteModal = (productId) => {
    setProductIdToDelete(productId);
    setShowDeleteModal(true);
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
  };

  const onEditProductDetails = (product) => {
    navigate(`/productList/edit`, { state: { product } });
  };

  return (
    <div style={mainContainer}>
      <div style={outerWrapper}>
        <div style={tableWrapper}>
          <div style={{ height: "92%", minWidth: "110%" }}>
            {products?.length === 0 ||
            products?.length === undefined ||
            products?.length === null ? (
              <div style={{ width: "70vw" }}>
                <CustomEmptyView />
              </div>
            ) : (
              <>
                <table style={table}>
                  <ProductTableHeader />
                  <ProductTableBody
                    products={products}
                    onViewProductDetails={onViewProductDetails}
                    onEditProductDetails={onEditProductDetails}
                    handleShowDeleteModal={handleShowDeleteModal}
                    onViewBtnShow={
                      userData?.data?.user_role_name === Strings.Admin
                        ? true
                        : userPermissions.viewProductBtn
                    }
                    onEditBtnShow={
                      userData?.data?.user_role_name === Strings.Admin
                        ? true
                        : userPermissions.editProductBtn
                    }
                    onDeleteBtnShow={
                      userData?.data?.user_role_name === Strings.Admin
                        ? true
                        : userPermissions.deleteProductBtn
                    }
                  />
                </table>
              </>
            )}
          </div>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>




      {showDeleteModal && (
        <DeleteConfirmationPopup
          isVisible={showDeleteModal}
          onCancel={handleCancelDelete}
          onDelete={handleDeleteProduct}
          title={Strings.deleteTitle}
          icons={Icons.deleteWithCircle}
        />
      )}
    </div>
  );
};

const mainContainer = {
  borderRadius: "10px",
  height: "100%",
  margin: "20px 25px",
};

const outerWrapper = {
  borderRadius: "4px",
  boxShadow: "0px 0px 3px #e6e6e6",
  maxWidth: "100%",
  height: "100%",
  backgroundColor: Colors.white,
};

const tableWrapper = {
  overflowY: "scroll",
  overflowX: "scroll",
  height: "100%",
};

const table = {
  minWidth: "100%",
  borderCollapse: "separate",
  borderSpacing: "0px",
};

export default ProductTable;
